import * as z from 'zod';

// Types
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { MediaZod } from '@/types/MediaType';

export const IllustrationItemZod = z.object({
  id: z.number(),
  positionY: z.enum(['start', 'center', 'end']),
  image: MediaZod,
});

export const IllustrationLineItemZod = z.object({
  id: z.number(),
  positionY: z.enum(['start', 'center', 'end']),
  positionX: z.enum(['start', 'center', 'end']),
  items: z.array(IllustrationItemZod),
});

export const IllustrationColumnItemZod = z.object({
  id: z.number(),
  positionY: z.enum(['start', 'center', 'end']),
  lines: z.array(IllustrationLineItemZod),
});

export const IllustrationZod = z.object({
  __component: z.literal('block.illustration'),
  id: z.number(),
  columns: z.array(IllustrationColumnItemZod),
  waveWrapper: WaveWrapperZod.nullable(),
});

export type IllustrationType = z.infer<typeof IllustrationZod>;
